export default {
  //代码里的key(唯一标识): '简体中文',
  lang: 'zh_CN',
  appIntroduction: '热门 Movie & Drama 随时免费看',
  noMoreTip: '你已经刷到底了,没有更多内容了~',
  navigator: {
    home: '首页',
    all: '所有内容',
    news: '文章资讯',
    download: '下载APP',
    contact: '关于我们',
    joinUs: '加入我们'
  },
  seo: {
    title: 'Loklok-全球高清视频免费在线观看',
    keywords: 'Loklok, Loklok app, loklok tv, Loklok official website, Loklok web,Loklok movie,在线观看,免费观看,免费看剧,电影,电视剧,韩剧,动漫,甜宠剧,美剧,流媒体,幸福,海贼王,单身即地狱,哈利比特,泰版流星花园,精灵旅社,欢乐好声音,国王排名,咒术回战,进击的巨人,鱿鱼游戏,寂静之海等',
    description: '热门剧集急速更新,美国电影大片,悬疑,喜剧,恋爱韩剧,惊悚,综艺都在Loklok,高清画面,多语言字幕免费在线观看。',
    ogImage: 'https://static.loklok.video/img/tw-cn.png',
    index: {
      title: 'Loklok-全球高清视频免费在线观看-海量热门剧集、高分电影推荐',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk, 韩剧,美剧,泰剧,电影,电视剧,动漫,综艺,bl,gl,好莱坞,丧尸, 禁忌之恋,love affair, all of us are dead',
      description: 'loklok是聚集全球热门高分电视剧、电影、动漫的视频内容平台。拥有超多海外精品剧集、热门爆款电影,多种字幕可供选择,影视资源丰富,超高清HD 4k画质,热门新片全网首发！'
    },
    allPage: {
      title: 'Loklok-全球高清视频免费在线观看- 电影,剧集,动漫,美剧,泰剧,韩剧,日剧应有尽有',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk,  animation,anime,blockbuster movies,new episode,2022 new release,premiere,sci-fi,sweet romance,comedy,action,love,在线观看,免费观看,免费看剧,僵尸校园,泰版流星花园,亢奋 第二季,二十五 二十一,气象厅的人们,幽灵医生,女神降临,魔法满屋,梦魇绝镇,社内相亲,雪滴花,你和我的警察课堂,假偶天成',
      description: 'loklok拥有海量爆款影视内容,时下最新最热电视剧电影免费看！多元化的高清内容、个性化的用户体验,热门影视应有尽有。热门最新电影、超高清HD、4K上映电影、喜剧、美剧、多种字幕可供选择。'
    },
    articles: {
      title: 'loklok news - 最新最热影视资讯、热门影评、最值得看的全球好片大搜罗,你想了解的影视信息每日放送！',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk, 在线观看,免费观看,免费看剧,最新影视资讯,影片推荐,热门影评,2022影视,新片首发,2022值得观看,2022院线电影,2023值得期待的电影, 浴血黑帮 第六季,进击的巨人 最终季,那年,我们的夏天,精灵旅社4：变身大冒险,幸福',
      description: 'loklok热门影视内容即搜即得,各类电影电视剧排行榜24h即时更新,热门影视内容实时呈现,剧荒就来loklok,最新热门电影资讯,热门影评,最新电视剧影评'
    },
    download: {
      title: 'loklok提供官方最新版本的Google play下载,App Store下载,apk下载,各大应用商店下载,在loklok手机端免费在线观看视频',
      keywords: 'Loklok, Loklok app, loklok 下载, loklok pc, loklok apk, loklok 下载,在线观看,免费观看,免费看剧,下载 loklok,  loklok 下载 apk, loklok ios 下载, loklok android 下载, loklok googleplay, loklok pc 下载, loklok 最新版, loklok 官网, how to 下载 Loklok, Loklok 桌面端, Loklok pad',
      description: '下载loklok app,可免费在线观看极速高清最新海内外电影、电视剧。下载最新版本loklok app,可下载安装后通过手机端扫描网站二维码,pc端同时在线播放。'
    },
    search: {
      title: 'loklok - 找到你喜欢的视频资源',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk,在线观看,免费观看,免费看剧,找剧,搜索剧集,热门剧集榜单,电影榜,美剧榜,泰剧榜,韩剧榜,电影 top10,剧集top10, 2022影视 top100,2021影视 top100',
      description: 'loklok根据观看、搜索热度每日实时更新推荐最受欢迎的全球热门剧集、电影等,解决剧荒烦恼,提升观看体验'
    },
    contact: {

    }
  },
  globalTip: {
    emptyTip: '找不到资源',
    searchOther: '尝试搜索其他内容'
  },
  loginModule: {
    title: '登录',
    loginMethod: '使用loklok APP扫描二维码',
    loginMethodTip: '（版本需升级至1.7.0及以上）',
    howToDownload: '如何下载loklok',
    clickMe: '点我',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    codeExpired: '二维码过期了！',
    refreshButton: '刷新',
    loginButton: '登录',
    loginTip: '登录后免费观看全站内容',
    logoutButton: '退出登录',
    logoutTip: '享受观影吧！',
    areYouSure: '确定要退出登录吗？',
    sure: '确定',
    cancel: '取消'
  },
  toTop: {
    downloadApp: '下载 App',
    backToTop: '返回顶部'
  },
  indexPage: {
    title: 'LolokTV',
    more: '更多',
    seeMore: '查看更多'
  },
  searchPage: {
    resultTitle: '搜索到以下内容：',
    rank: 'Loklok热搜榜',
    play: '播放',
    popularSearch: '热门搜索',
    top1: '第1名',
    top2: '第2名',
    top3: '第3名',
    top4: '第4名',
    top5: '第5名',
    top6: '第6名',
    top7: '第7名',
    top8: '第8名',
    top9: '第9名',
    top10: '第10名',
    emptyTip: '抱歉,我们没有那个内容',
    emptyDesc: '试试搜索其他电影或电视剧'
  },
  filterPage: {
    emptyTip: '抱歉,我们没有那个内容',
    emptyDesc: '试试搜索其他电影或电视剧'
  },
  newsPage: {
    listTitle: '最新资讯'
  },
  downloadPage: {
    scanQR: '扫码下载APP',
    title1: '热门Movie&Drama',
    tip1: '随时免费看',
    title2: '多语言字幕',
    tip2: '轻松看剧',
    title3: 'PC/手机实时同步'
  },
  detailPage: {
    autoTranslation: '自动翻译',
    fiveMiniteTip: '只能看5分钟，看完整片',
    loginTip2InDetailPage: '使用loklok APP扫描下方二维码,完成登录后观看剩余内容',
    category: '分类',
    moreDesc: '更多',
    youMayLike: '猜你喜欢',
    relatedSeries: '相关系列',
    norelatedSeries: '没有相关系列',
    emptyDesc: '抱歉,我们没有那个内容',
    emptyTip: '抱歉,我们没有那个内容',
    vip: {
      dialog: {
        t1: '开通VIP',
        t2: '如需查看全部内容，请至App内开通VIP',
        t3: '可通过以下方式下载App',
        t4: '已有VIP?请<span class="active">点击此处</span>登录',
        t5: '已有VIP？请<span class="active">刷新</span>后继续观看',
        t6: '您已观看{num}分钟，若想继续观看完整影片，请前往App，或在App内开通VIP后，您可以继续浏览该影片'
      },
      player: {
        tip1: '只能观看{num}分钟，观看全片<span class="active">请至App内</span>或<span class="active">开通VIP</span>'
      },
      episodes: {
        tip1: '成为VIP，畅享全部内容'
      }
    }
  },
  playerModule: {
    NETWORK_LOADING: '浏览器正在下载数据',
    NETWORK_NO_SOURCE: '未找到音频/视频来源',
    MEDIA_ERR_ABORTED: '取回过程被用户中止',
    MEDIA_ERR_NETWORK: '当下载时发生错误',
    MEDIA_ERR_DECODE: '播放解析失败：无法播放文件',
    MEDIA_ERR_SRC_NOT_SUPPORTED: '不支持的音频/视频格式',
    REPLAY: '重播',
    ERROR: '网络连接似乎出现了问题',
    PLAY_TIPS: '播放',
    PAUSE_TIPS: '暂停',
    PLAYNEXT_TIPS: '下一集',
    DOWNLOAD_TIPS: '下载',
    ROTATE_TIPS: '旋转',
    RELOAD_TIPS: '重新载入',
    FULLSCREEN_TIPS: '进入全屏',
    EXITFULLSCREEN_TIPS: '退出全屏',
    CSSFULLSCREEN_TIPS: '进入样式全屏',
    EXITCSSFULLSCREEN_TIPS: '退出样式全屏',
    TEXTTRACK: '字幕',
    PIP: '画中画',
    MINIPLAYER: '迷你播放器',
    SCREENSHOT: '截图',
    LIVE: '正在直播',
    OFF: '关闭',
    MINIPLAYER_DRAG: '点击按住可拖动视频',
    AIRPLAY_TIPS: '隔空播放',
    onlyPlayTip: '只播放 {msg} 分钟,登录看全片',
    loginTextButton: '登录',
    replayButton: '重播',
    nextButton: '下一集',
    refreshButton: '刷新',
    episode: '集'
  },
  contact: {
    business: '商务合作',
    question: '问题反馈'
  },
  download_nd: {
    desc: '海量影视剧免费看',
    scanQR: '扫描二维码下载App或者'
  },
  win: {
    feedback: {
      que: '常见问题说明',
      que1: '常见问题',
      content: '反馈内容',
      contact: '联系方式',
      submit: '提交反馈',
      tip1: '请尽量详细描述，也可以提供相关截图',
      tip2: '请输入您的邮箱',
      tip5: '上传图片大小必须小于{num}k',
      tip6: '最多反馈4张图片',
      tip3: '已提交，请耐心等待',
      tip4: '反馈内容需要不少于10个字',
      error: '系统错误'
    }
  },
  tv: {
    vip: {
      title: '请选择您的商品',
      tip1: '登录后您可以查看支付二维码。',
      refresh: '刷新',
      tip2: '扫描二维码进行付款',
      recharge: '充值协议',
      renewal: '续约协议',
      login: '现在登录',
      tip3: '登录后查看',
      noOpen: '标准VIP未开通',
      gift: '礼物',
      succ: '刷新成功',
      fail: '刷新失败',
      day: '标准VIP1天',
      days: '标准VIP{x}天',
      expiration: '标准VIP到期时间：{x}',
      expired: '您的VIP已过期，请尽快续费。',
      interests1: '享受1080P高清画质',
      interests2: '所有内容解锁',
      interests3: '多端设备登录'
    }
  }
}